window.Products.Clothing.ComfortSlimfitTShirt = function() {
};
window.Products.Clothing.ComfortSlimfitTShirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ComfortSlimfitTShirt.dpi = 150;
window.Products.Clothing.ComfortSlimfitTShirt.has_3d = true;
window.Products.Clothing.ComfortSlimfitTShirt.id = 102;
window.Products.Clothing.ComfortSlimfitTShirt.slug = 'comfort-slimfit-t-shirt';
window.Products.Clothing.ComfortSlimfitTShirt.syncColors = true;
window.Products.Clothing.ComfortSlimfitTShirt.texturesLoaded = 0;
window.Products.Clothing.ComfortSlimfitTShirt.texturesLoading = false;
window.Products.Clothing.ComfortSlimfitTShirt.use_glb = true;

window.Products.Clothing.ComfortSlimfitTShirt.prototype.outsideObject = 0;
window.Products.Clothing.ComfortSlimfitTShirt.prototype.detailsObject = 1;
window.Products.Clothing.ComfortSlimfitTShirt.prototype.position = 0.1;

window.Products.Clothing.ComfortSlimfitTShirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color.includes("antique") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer, {
		color: color
	});
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.ComfortSlimfitTShirt.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"antique_sapphire": 0x017598,
		"azalea": 0xee81ae,
		"cherry_red": 0xb81d3f,
		"red": 0xC92426,
		"dark_heather": 0x5e6168,
		"heather_purple": 0x917eb9,
		"heather_royal": 0x6484c3,
		"irish_green": 0x15af71,
		"kiwi": 0x9dbb75,
		"navy": 0x2b2e3f,
		"sport_grey": 0xbababa,
	};

	return new THREE.Color(colors[_name]);
};